module.exports = __webpack_public_path__ + "pattern7.372dee6df561fd2ed153.png";


//////////////////
// WEBPACK FOOTER
// /Users/liyankai/Documents/github/seiya_web.git/src/assets/images/pattern7.png
// module id = ../../../../../src/assets/images/pattern7.png
// module chunks = styles